import { getAssetLinkByHandle } from '@doltech/utils/lib/url';
import Image from 'next/image';
import * as React from 'react';

function SvgImageEmptyResult() {
  return (
    <Image
      src={
        getAssetLinkByHandle({
          handle: 'nvtAtNNGQZ6WdMABgvuO',
        }) || ''
      }
      width={1164}
      height={668}
      layout="responsive"
    />
  );
}

export const ImageEmptyResult = React.memo(SvgImageEmptyResult);
